module.exports = __webpack_public_path__ + "img/interesse_3_selecionado.f9316429.svg";